import type {
  DimensionPreset,
  ProductTypeConfig,
  UnitLabels,
} from "./product-presets";

export function findPreset(
  config: ProductTypeConfig,
  presetId: string,
): DimensionPreset | undefined {
  return config.presets.find((preset) => preset.id === presetId);
}

export function presetWeightLbs(
  config: ProductTypeConfig,
  preset: DimensionPreset,
): number {
  return preset.weightLbs ?? config.defaultWeightLbs;
}

export function presetStackable(
  config: ProductTypeConfig,
  preset: DimensionPreset,
): boolean {
  return preset.stackable ?? config.defaultStackable;
}

export function presetUnitLabels(
  config: ProductTypeConfig,
  preset: DimensionPreset | undefined,
): UnitLabels {
  return (
    preset?.unitLabels ?? {
      singular: config.singularLabel,
      plural: config.pluralLabel,
    }
  );
}
